import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { HeartPulse, Loader2, Stethoscope } from "lucide-react";
import axios from "axios";
import { API, fmtErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function PortalLogin() {
    const navigate = useNavigate();
    const [uid, setUid] = useState("");
    const [phone, setPhone] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            const { data } = await axios.post(`${API}/portal/login`, { patient_uid: uid, phone });
            localStorage.setItem("portal_token", data.token);
            navigate("/portal/dashboard");
        } catch (err) {
            setError(fmtErr(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#F8FAF9] flex items-center justify-center px-4">
            <div className="w-full max-w-md animate-fade-up">
                <div className="mb-8 flex flex-col items-center">
                    <img src="/zen-logo.webp" alt="Zen Hospital" className="h-14 w-auto" data-testid="brand-logo-img" />
                    <p className="mt-2 text-xs text-slate-500">Your visits & prescriptions, anytime</p>
                </div>
                <div className="rounded-2xl border border-slate-200 bg-white p-6 sm:p-8 shadow-sm" data-testid="portal-login-card">
                    <h2 className="font-heading text-2xl font-bold text-slate-900">View your records</h2>
                    <p className="mt-1 text-sm text-slate-500">Enter the Patient ID given by your clinic and your registered phone number</p>
                    <form onSubmit={submit} className="mt-6 space-y-4">
                        <div className="space-y-1.5">
                            <Label>Patient ID</Label>
                            <Input data-testid="portal-patient-id-input" required value={uid} onChange={(e) => setUid(e.target.value)} placeholder="PT-1001" className="font-mono2" />
                        </div>
                        <div className="space-y-1.5">
                            <Label>Registered Phone Number</Label>
                            <Input data-testid="portal-phone-input" required value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="9876543210" />
                        </div>
                        {error && <p data-testid="portal-login-error" className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">{error}</p>}
                        <Button data-testid="portal-login-submit-btn" type="submit" disabled={loading} className="w-full bg-[#E06D1F] hover:bg-[#B45309] text-white">
                            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Access My Records
                        </Button>
                    </form>
                </div>
                <p className="mt-6 text-center text-sm text-slate-500">
                    <Link to="/login" data-testid="doctor-login-link" className="inline-flex items-center gap-1.5 font-medium text-[#C2410C] hover:underline">
                        <Stethoscope className="h-3.5 w-3.5" /> Doctor sign in
                    </Link>
                </p>
            </div>
        </div>
    );
}
